<!--
 * @Descripttion: 首页组件
 * @Author: congz
 * @Date: 2020-06-04 11:22:40
 * @LastEditors: congz
 * @LastEditTime: 2020-08-12 21:20:08
--> 

<template>
  <div class="home" id="home" name="home">
    <div class="hero">
      <div class="hero-strip">Super Collection</div>
      <div class="hero-content">
        <div class="block">
          <el-carousel height="520px">
            <el-carousel-item v-for="item in carousels" :key="item.id">
              <div class="carousel-item">
                <el-image
                  :src="item.img_path"
                  fit="cover"></el-image>
                <div class="carousel-mask">
                  <div class="carousel-content">
                    <div class="carousel-eyebrow">Elevate Your Style With Elegant Ethnic Wear</div>
                    <div class="carousel-title">Discover Timeless Sarees, Kurtis &amp; More</div>
                    <div class="carousel-desc">
                      Explore beautifully crafted sarees, kurtis, blouses, leggings, dupattas, and festival
                      collections designed to celebrate your beauty, confidence, and individuality.
                    </div>
                    <div class="carousel-desc">
                      Indulge in premium fabrics, rich colors, and fine detailing — perfect for every occasion,
                      from daily wear to festive celebrations.
                    </div>
                    <router-link class="carousel-view" :to="{ path: '/goods/details', query: {productID:item.product_id} }">
                      View
                    </router-link>
                  </div>
                </div>
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
    </div>
    <div class="hero-badges">
      <span>Secure Payments</span>
      <span>Easy Returns</span>
      <span>Festival Sale Live</span>
      <span>Cash on Delivery Available</span>
    </div>
  
 
    
    <div class="main-box">
      <div class="main">
          <div class="home-section-title">✨ Best Sellers You’ll Love</div>
        <!-- 手机商品展示区域 -->
        <div class="phone">
          <div class="box-hd">
            <div class="title">Saree</div>
          </div>
          <div class="box-bd">
            <div class="promo-list">
            </div>
            <div class="list">
              <!-- <MyList :list="phonesList" :isMore="true"></MyList> -->
                            <ProductGrid :list="phonesList" :isMore="true"></ProductGrid>

            </div>
          </div>
        </div>
        <!-- 手机商品展示区域END -->


        <div class="home-intro">
          <div class="home-intro-text">
            <div class="home-intro-title">Super Collection</div>
            <div class="home-intro-subtitle">We Bring You Elegant Sarees, Ethnic Wear &amp; Everyday Fashion</div>
            <p>Discover beautifully crafted sarees, kurtis, blouses, leggings, and more — designed to celebrate your style with comfort, quality, and confidence.</p>
            <p>We offer curated collections inspired by tradition and shaped for today’s fashion. Choose from our latest arrivals or explore timeless classics crafted with care.</p>
          </div>
          <div class="home-intro-media">
            <img :src="'https://india-shop.oss-ap-southeast-1.aliyuncs.com/shop4/769011432/58153W_5-430x573.webp'" alt />
          </div>
        </div>
        
        <!-- 家电商品展示区域 -->
        <div class="appliance" id="promo-menu">
          <div class="box-hd">
            <div class="title">kurtaSet</div>
            <div class="more" id="more">
              <MyMenu :val="2" @fromChild="getChildMsg">
                <span slot="2">Hot</span>
                <span slot="1">Popular </span>
              </MyMenu>
            </div>
          </div>
          <div class="box-bd">
            <div class="promo-list">
              <ul>
                <router-link :to="{ path: '/goods/details', query: {productID:769005591} }">
                  <li>
                    <img
                      :src="'https://india-shop.oss-ap-southeast-1.aliyuncs.com/shop4/769005591/719BOYCsthL._SY879_-430x637.jpg'"
                    />
                  </li>
                </router-link>
                <router-link :to="{ path: '/goods/details', query: {productID:769006299} }">
                  <li>
                    <img
                      :src="'https://india-shop.oss-ap-southeast-1.aliyuncs.com/shop4/769006299/81-OTIjtaXL._SY741_-430x664.jpg'"
                    />
                  </li>
                </router-link>
              </ul>
            </div>
            <div class="list">
              <MyList :list="applianceList" :isMore="true"></MyList>
            </div>
          </div>
        </div>
        <!-- 家电商品展示区域END -->

        <!-- 配件商品展示区域 -->
        <div class="home-section-title">✨ Curated Just For You</div>
        <div class="accessory" id="promo-menu">
          <div class="box-hd">
            <div class="title">Trendy</div>
            <div class="more" id="more">
              <MyMenu :val="3" @fromChild="getChildMsg2">
                <span slot="3">Hot</span>
                <span slot="2">Sunglasses</span>
                <span slot="1">ShortKurtis</span>
              </MyMenu>
            </div>
          </div>
          <div class="box-bd">
            <div class="promo-list">
              <ul>
                <router-link :to="{ path: '/goods/details', query: {productID:769004496} }">
                  <li>
                    <img
                      :src="'https://india-shop.oss-ap-southeast-1.aliyuncs.com/shop4/769004496/71GvYz-zjHL._SX679_-430x430.jpg'"
                      alt
                    />
                  </li>
                </router-link>
                <router-link :to="{ path: '/goods/details', query: {productID:769013066} }">
                  <li>
                    <img
                      :src="'https://india-shop.oss-ap-southeast-1.aliyuncs.com/shop4/769013066/SAUS0044328_LAVENDER_6-430x609.webp'"
                      alt
                    />
                  </li>
                </router-link>
              </ul>
            </div>
            <div class="list">
              <MyList :list="accessoryList" :isMore="true"></MyList>
            </div>
          </div>
        </div>
        <!-- 配件商品展示区域END -->
      </div>
    </div>
  </div>
</template>
<script>
import * as carouselsAPI from '@/api/carousels/'
import * as productsAPI from '@/api/products/'
import * as rankingAPI from '@/api/ranking/'
import ProductGrid from '@/components/ProductGrid'

export default {
  components: { ProductGrid },
  data() {
    return {
      carousels: [], // 轮播图数据
      phonesList: [], // 手机商品列表
      televisionsList: [], // 小米电视商品列表
      applianceList: [], // 家电商品列表
      applianceHotList: [], //热门家电商品列表
      accessoryList: [], //配件商品列表
      accessoryHotList: [], //热门配件商品列表
      phoneShellsList: [], // 保护套商品列表
      chargersList: [], //充电器商品列表
      applianceActive: 1, // 家电当前选中的商品分类
      accessoryActive: 1, // 配件当前选中的商品分类
      start: 0,
      limit: 7
    }
  },
  watch: {
    // 家电当前选中的商品分类，响应不同的商品数据
    applianceActive: function(val) {
      // 页面初始化的时候把applianceHotList(热门家电商品列表)直接赋值给applianceList(家电商品列表)
      // 所以在切换商品列表时判断applianceHotList是否为空,为空则是第一次切换,把applianceList赋值给applianceHotList
      if (this.applianceHotList == '') {
        this.applianceHotList = this.televisionsList
      }
      if (val == 1) {
        // 1为热门商品
        this.applianceList = this.applianceHotList
        return
      }
      if (val == 2) {
        // 2为电视商品
        this.applianceList = this.televisionsList
        return
      }
    },
    accessoryActive: function(val) {
      // 页面初始化的时候把accessoryHotList(热门配件商品列表)直接赋值给accessoryList(配件商品列表)
      // 所以在切换商品列表时判断accessoryHotList是否为空,为空则是第一次切换,把accessoryList赋值给accessoryHotList
      if (this.accessoryHotList == '') {
        this.accessoryHotList = this.chargersList
      }
      if (val == 3) {
        // 1为热门商品
        this.accessoryList = this.accessoryHotList
        return
      }
      if (val == 2) {
        // 2为保护套商品
        this.accessoryList = this.phoneShellsList
        return
      }
      if (val == 1) {
        //3 为充电器商品
        this.accessoryList = this.chargersList
        return
      }
    }
  },
  activated() {
    // 获取首页数据
    this.load()
  },
  methods: {
    load() {
      carouselsAPI
        .listCarousels()
        .then(res => {
          if (res.status == 200) {
            this.carousels = res.data
          } else {
            this.notifyError('Failed', res.msg)
          }
        })
        .catch(err => {
          this.notifyError('Failed', err)
        })
      //获取热门家电
      rankingAPI
        .listElecRanking()
        .then(res => {
          if (res.status === 200) {
            this.applianceHotList = res.data
            this.applianceList = res.data
          } else {
            this.notifyError('Failed')
          }
        })
        .catch(err => {
          this.notifyError('Failed', err)
        })
      //获取热门配件
      rankingAPI
        .listAcceRanking()
        .then(res => {
          if (res.status === 200) {
            this.accessoryHotList = res.data
            this.accessoryList = res.data
          } else {
            this.notifyError('Failed')
          }
        })
        .catch(err => {
          this.notifyError('Failed', err)
        })
      //获取手机列表
      this.getProduct(21, 'chargersList')

      this.getProduct(27, 'phonesList')
      //获取电视列表
      this.getProduct(23, 'televisionsList')
      //获取保护套列表
      this.getProduct(5, 'phoneShellsList')
      //获取充电器列表
    },
    // 获取家电模块子组件传过来的数据
    getChildMsg(val) {
      this.applianceActive = val
    },
    // 获取配件模块子组件传过来的数据
    getChildMsg2(val) {
      this.accessoryActive = val
    },
    // 获取各类商品数据方法封装
    getProduct(categoryID, val) {
      productsAPI
        .listProducts(categoryID, this.start, this.limit)
        .then(res => {
          if (res.status === 200) {
            this[val] = res.data.items
          } else {
            this.notifyError('Failed', res.msg)
          }
        })
        .catch(err => {
          this.notifyError('Failed', err)
        })
    }
  },
  beforeRouteEnter(to, from, next) {
    // 添加背景色
    document
      .querySelector('body')
      .setAttribute('style', 'background-color:#ffffff')
    next()
  },
  beforeRouteLeave(to, from, next) {
    // 去除背景色
    document
      .querySelector('body')
      .setAttribute('style', 'background-color:#f5f5f5')
    next()
  }
}
</script>
<style scoped>
@import '../assets/css/index.css';

.phone .box-bd .list {
  width: 100%;
}
.phone .box-bd .promo-list {
  display: none;
}
</style>
